











import { Component, Vue } from 'vue-property-decorator'

import { Project } from '@/model/Project'
import NewProject from '../../components/core/project/NewProject.vue'
import router from '@/router'
import store from '@/store'

@Component({
  components: {
    NewProject,
  },
})
export default class ViewNewProject extends Vue {
  project: Project = {}
  user: Project = {}

  get isAdmin(): boolean {
    return store.getters.isAdmin
  }

  get targetUserId(): number {
    const userIdFromRoute = this.$route.params.userId
    if (userIdFromRoute && this.isAdmin) {
      return parseInt(userIdFromRoute)
    }
    return store.getters.loggedUser.id
  }

  async mounted(): Promise<void> {
    if (this.isAdmin && this.targetUserId !== store.getters.loggedUser.id) {
      await store.dispatch('getUsers')
    }
  }

  goBack = (): void => {
    router.back()
  }

  addProject = (project: Project): void => {
    store
      .dispatch('addProject', {
        project: { ...project, main: false },
        userId: this.targetUserId,
      })
      .then(json => {
        console.log(json)
        if (json.success) {
          router.push(`/project/${json.data.id}`)
        }
      })
  }
}
